// A saved address stores its label as TEXT in whatever language the citizen had when they saved it
// ("Home" / "घर"). Display must follow the language they are reading now, so the three presets are
// recognised in both languages and re-translated; a custom label ("Mom's house") is shown as typed.
const PRESETS = {
  home: ["home", "घर"],
  work: ["work", "काम"],
  other: ["other", "अन्य"],
};

export function addressPreset(label) {
  const norm = String(label || "").trim().toLowerCase();
  return Object.keys(PRESETS).find((key) => PRESETS[key].includes(norm)) || null;
}

export function addressLabel(label, t) {
  const key = addressPreset(label);
  return key ? t(`addresses.label${key.charAt(0).toUpperCase()}${key.slice(1)}`) : label;
}
